import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Products.css';

const Products = () => {
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxTitle, setLightboxTitle] = useState('');

  const toggleCategory = (index) => {
    if (expandedCategory === index) {
      setExpandedCategory(null);
    } else {
      setExpandedCategory(index);
    }
  };

  const openLightbox = (image, title) => {
    setLightboxImage(image);
    setLightboxTitle(title);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
    setLightboxTitle('');
  };

  // Helper function to get category ID for linking
  const getCategoryId = (title) => {
    const mapping = {
      "AERIAL BUNDLED CABLES (ABC)": "abc",
      "ARMOURED ALUMINIUM CABLES": "armoured-al",
      "ARMOURED COPPER CABLES": "armoured-cu",
      "AUTOMOTIVE CABLES": "automotive",
      "CNC CABLES (Concentric Neutral)": "cnc",
      "DOMESTIC CABLES": "domestic",
      "FLEXIBLE CABLES": "flexible",
      "NON-ARMOURED ALUMINIUM CABLES": "nonarm-al",
      "NON-ARMOURED COPPER CABLES": "nonarm-cu",
      "SOLAR CABLES": "solar",
      "SUBMERSIBLE CABLES": "submersible",
      "TWIN CABLES": "twin",
      "WELDING CABLES": "welding",
      "WINDING WIRES": "winding",
      "BARE COPPER": "bare",
      "BARE ALUMINIUM": "bare-al"
    };
    return mapping[title] || '';
  };

  const productCategories = [
    {
      title: "AERIAL BUNDLED CABLES (ABC)",
      icon: "☁️",
      color: "#8B0000",
      description: "UV resistant XLPE insulated overhead cables",
      image: "/images/products/abc.JPG",
      specs: [
        "ABC AL Cable 3C 50 + 54.6 SqMm",
        "ABC Cable 2C 10 SqMm",
        "ABC Cable 2C 16 SqMm"
      ],
      sizes: ["10mm²", "16mm²", "50mm²", "54.6mm²"],
      voltage: "600/1000V",
      standard: "KS 2650",
      application: "Overhead power distribution, rural electrification"
    },
    {
      title: "ARMOURED ALUMINIUM CABLES",
      icon: "🛡️⚪",
      color: "#1C1C1C",
      description: "Steel wire armoured aluminium cables for industrial applications",
      image: "/images/products/armoured-cable.jpg",
      specs: [
        "1C 185 SqMm", "1C 240 SqMm", "1C 25 SqMm", "1C 300 SqMm",
        "1C 400 SqMm", "1C 500 SqMm", "1C 630 SqMm",
        "3.5C 25 SqMm", "3.5C 120 SqMm", "3.5C 150 SqMm", "3.5C 240 SqMm",
        "4C 6.0 SqMm SOLID", "4C 10 SqMm", "4C 16 SqMm", "4C 25 SqMm",
        "4C 35 SqMm", "4C 50 SqMm", "4C 70 SqMm", "4C 95 SqMm",
        "4C 120 SqMm XLPE", "4C 150 SqMm", "4C 185 SqMm", "4C 240 SqMm XLPE"
      ],
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA"
    },
    {
      title: "ARMOURED COPPER CABLES",
      icon: "🛡️🔴",
      color: "#8B0000",
      description: "High conductivity copper armoured cables",
      image: "/images/products/armoured-cable.jpg",
      specs: [
        "1C 70 SqMm", "1C 120 SqMm", "1C 240 SqMm", "1C 300 SqMm",
        "1C 400 SqMm", "1C 630 SqMm",
        "2C 1.5 SqMm", "2C 10 SqMm", "2C 16 SqMm", "2C 2.5 SqMm",
        "2C 25.0 SqMm", "2C 35 SqMm", "2C 4.0 SqMm",
        "3C 2.5 SqMm", "3C 25.0 SqMm", "3C 4.0 SqMm", "3C 6.0 SqMm", "3C 95 SqMm",
        "4C 1.5 SqMm", "4C 10 SqMm", "4C 120 SqMm", "4C 150 SqMm",
        "4C 16 SqMm", "4C 185 SqMm", "4C 2.5 SqMm", "4C 25 SqMm",
        "4C 240 SqMm", "4C 35.0 SqMm", "4C 4.0 SqMm", "4C 50 SqMm",
        "4C 6.0 SqMm", "4C 70 SqMm", "4C 95 SqMm",
        "5C 1.5 SqMm", "5C 10 SqMm", "5C 16 SqMm", "5C 2.5 SqMm",
        "6C 1.5 SqMm", "7C 1.5 SqMm", "10C 1.0 SqMm", "10C 1.5 SqMm",
        "10C 4.0 SqMm", "11C 1.5 SqMm", "12C 1.5 SqMm", "12C 2.5 SqMm",
        "14C 1.0 SqMm", "14C 1.5 SqMm", "14C 4.0 SqMm",
        "19C 2.5 SqMm", "24C 1.5 SqMm", "27C 1.5 SqMm"
      ],
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE + SWA"
    },
    {
      title: "AUTOMOTIVE CABLES",
      icon: "🚗",
      color: "#1C1C1C",
      description: "PVC covered conductors for automotive wiring",
      image: "/images/products/wires-cables.jpg",
      specs: [
        "0.35 mm² (Various colors: BK/RD, BK/WH, BR, BR/WH, Light GR, Violet, PINK, RD, WH, YL, etc.)",
        "0.5 mm² (Various colors: BK, GR, BL/BK, BL/YL, YL, YL/BK, YL/BL, YL/GR, BR/BL, BR/WH, BR/YL, RD/BK, RD/YL, WH, WH/GR, WH/RD, etc.)",
        "0.75 mm² (Various colors: BK, BL/BK, BL/RD, BR/BL, BR/WH, GR, RD, RD/BK, RD/YL, WH, WH/RD)",
        "1.0 mm² (Various colors: BK, BK/WH, BL, BR, GR, RD, WH, WH/BK)",
        "1.5 mm² (BL, etc.)",
        "2.5 mm² (YL, etc.)",
        "5.0 mm² (RD)",
        "16.0 mm² (YG)"
      ],
      standard: "KS 04-314",
      colors: ["BK", "RD", "WH", "YL", "GR", "BL", "BR", "OR", "PINK", "VIOLET", "LIGHT GR"],
      application: "Automotive wiring harnesses"
    },
    {
      title: "CNC CABLES (Concentric Neutral)",
      icon: "⚡",
      color: "#8B0000",
      description: "Concentric neutral cables for power distribution",
      image: "/images/products/cnc-cable.jpg",
      specs: [
        "1C 10 SqMm",
        "1C 16 SqMm"
      ],
      sizes: ["10mm²", "16mm²"],
      voltage: "600/1000V",
      standard: "KS 1637",
      application: "Secondary distribution, service lines"
    },
    {
      title: "DOMESTIC CABLES",
      icon: "🏠",
      color: "#1C1C1C",
      description: "House wiring cables in various sizes and colors",
      image: "/images/products/domestic-cables.jpg",
      specs: [
        "Single Core 6.0 mm² Cu/PVC (YG)",
        "Single Core 10.0 mm² Cu/PVC (RD, BK)",
        "Single Core 12.0 mm² Cu/PVC (YG)",
        "Single Core 35.0 mm² Cu/PVC (RD, BK, YG)",
        "4.0 mm² SC Cu/PVC (RD)",
        "Twin Flat Cables (TF)",
        "Twin with Earth Cables (TWE) 1.0-10.0 mm²"
      ],
      sizes: ["1.0mm²", "1.5mm²", "2.5mm²", "4.0mm²", "6.0mm²", "10.0mm²", "12.0mm²", "16.0mm²", "35.0mm²"],
      colors: ["RD", "BK", "YG", "YL", "GR", "BL", "BR"],
      voltage: "450/750V",
      standard: "KS EAS 114"
    },
    {
      title: "FLEXIBLE CABLES",
      icon: "〰️",
      color: "#8B0000",
      description: "Flexible cables for industrial and general applications",
      image: "/images/products/flexible-cables.jpg",
      specs: [
        "1C 2.5 SqMm RD",
        "1C 35 SqMm",
        "1C 630 SqMm",
        "1C 95 SqMm",
        "2C 2.5 SqMm BK",
        "2C 4.0 SqMm BK",
        "2C 6.0 SqMm BK",
        "2C 10.0 SqMm BK",
        "2C 25.0 SqMm BK",
        "3C 0.5 SqMm BK",
        "3C 0.75 SqMm",
        "3C 1.5 SqMm BK/WH",
        "3C 2.5 SqMm BK",
        "3C 10.0 SqMm",
        "3.5C 70 SqMm",
        "4C 1.0 SqMm",
        "4C 1.5 SqMm",
        "4C 2.5 SqMm",
        "4C 10 SqMm",
        "4C 35 SqMm",
        "4C 50 SqMm",
        "5C 10 SqMm",
        "5C 35 SqMm",
        "40C 1.0 SqMm"
      ],
      sizes: ["0.5mm²", "0.75mm²", "1.0mm²", "1.5mm²", "2.5mm²", "4.0mm²", "6.0mm²", "10mm²", "25mm²", "35mm²", "50mm²", "70mm²", "95mm²", "630mm²"],
      voltage: "450/750V",
      standard: "KS EAS 117"
    },
    {
      title: "NON-ARMOURED ALUMINIUM CABLES",
      icon: "⚪",
      color: "#1C1C1C",
      description: "Unarmoured aluminium cables for general wiring",
      image: "/images/products/aluminium-single.jpg",
      specs: [
        "1C 150 SqMm",
        "1C 185 SqMm",
        "1C 240 SqMm",
        "1C 300 SqMm",
        "1C 630 SqMm",
        "4C 25 SqMm"
      ],
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE"
    },
    {
      title: "NON-ARMOURED COPPER CABLES",
      icon: "🔴",
      color: "#8B0000",
      description: "Unarmoured copper cables for general wiring",
      image: "/images/products/copper-single.jpg",
      specs: [
        "1C 150 SqMm",
        "1C 185 SqMm",
        "1C 240 SqMm",
        "1C 300 SqMm",
        "1C 630 SqMm",
        "3.5C 25.0 SqMm",
        "3C 2.5 SqMm"
      ],
      voltage: "600/1000V",
      standard: "KS IEC 60502-1",
      insulation: "PVC/XLPE"
    },
    {
      title: "SOLAR CABLES",
      icon: "☀️",
      color: "#1C1C1C",
      description: "Solar photovoltaic cables",
      image: "/images/products/solar-pump.jpg",
      specs: [
        "Solar Cable 6.0 SqMm x100 RD",
        "Solar Cable 10.0 SqMm x100 BK"
      ],
      voltage: "600/1000V",
      standard: "TUV Certified",
      application: "Solar panel connections"
    },
    {
      title: "SUBMERSIBLE CABLES",
      icon: "💧",
      color: "#8B0000",
      description: "Water-resistant cables for submersible pumps",
      image: "/images/products/submersible-cables.jpg",
      specs: [
        "Flat 3C 16 SqMm",
        "Flat 4C 1.5 SqMm",
        "Flat 4C 2.5 SqMm",
        "Flat 4C 4.0 SqMm",
        "Flat 4C 6 SqMm",
        "Flat 4C 10 SqMm",
        "Flat 4C 16 SqMm",
        "Round 2C 2.5 SqMm",
        "Round 2C 25.0 SqMm",
        "Round 4C 2.5 SqMm"
      ],
      sizes: ["1.5mm²", "2.5mm²", "4.0mm²", "6.0mm²", "10mm²", "16mm²", "25mm²"],
      voltage: "600/1000V",
      standard: "KS IEC 60502-1"
    },
    {
      title: "TWIN CABLES",
      icon: "⚡⚡",
      color: "#1C1C1C",
      description: "Twin flat and twin with earth cables",
      image: "/images/products/domestic-cables.jpg",
      specs: [
        "TF Cables CU 1.0 SqMm",
        "TF Cables CU 1.5 SqMm",
        "TF Cables CU 2.5 SqMm",
        "TWE Cables CU 1.0 SqMm",
        "TWE Cables CU 1.5 SqMm",
        "TWE Cables CU 2.5 SqMm",
        "TWE Cables CU 4.0 SqMm",
        "TWE Cables CU 6.0 SqMm",
        "TWE Cables CU 10.0 SqMm"
      ],
      sizes: ["1.0mm²", "1.5mm²", "2.5mm²", "4.0mm²", "6.0mm²", "10.0mm²"],
      voltage: "300/500V",
      standard: "KS EAS 114"
    },
    {
      title: "WELDING CABLES",
      icon: "⚡",
      color: "#8B0000",
      description: "Flexible cables for welding applications",
      image: "/images/products/welding-cable.jpg",
      specs: [
        "Welding Cable SC 16 SqMm (black)",
        "Welding Cable SC 35 SqMm",
        "Welding Cable SC 50 SqMm"
      ],
      sizes: ["16mm²", "35mm²", "50mm²"],
      voltage: "600/1000V",
      standard: "BS 638",
      insulation: "EPR/PCP"
    },
    {
      title: "WINDING WIRES",
      icon: "🌀",
      color: "#1C1C1C",
      description: "Enamelled copper winding wires for motors and transformers",
      image: "/images/products/copper-single.jpg",
      specs: [
        "0.193 mm (36 SWG)",
        "0.21 mm (35 SWG)",
        "0.25 mm (33 SWG)",
        "0.28 mm (32 SWG)",
        "0.295 mm (31 SWG)",
        "0.30 mm (31 SWG)",
        "0.315 mm (30 SWG)",
        "0.345 mm (29 SWG)",
        "0.40 mm (27 SWG)",
        "0.45 mm (26 SWG)",
        "0.50 mm (25 SWG)",
        "0.53 mm (24.5 SWG)",
        "0.56 mm (24 SWG)",
        "0.60 mm (24 SWG)",
        "0.61 mm (23 SWG)",
        "0.63 mm (23 SWG)",
        "0.67 mm (22.5 SWG)",
        "0.75 mm (21.5 SWG)",
        "0.80 mm (21 SWG)",
        "0.85 mm (20.5 SWG)",
        "0.95 mm (19.5 SWG)",
        "1.12 mm (18.5 SWG)",
        "1.18 mm (18.25 SWG)",
        "1.25 mm (18 SWG)",
        "1.40 mm (17 SWG)",
        "1.50 mm (16.5 SWG)",
        "1.60 mm (16 SWG)",
        "1.80 mm (15 SWG)",
        "2.0 mm (14 SWG)"
      ],
      standard: "IEC 60317",
      application: "Motor windings, transformer windings, coil windings"
    },
    {
      title: "BARE COPPER",
      icon: "🧵",
      color: "#8B0000",
      description: "Bare copper conductors",
      image: "/images/products/copper-single.jpg",
      specs: [
        "Bare 100mm",
        "1.38mm copper"
      ],
      application: "Earthing, overhead transmission, busbars"
    },
    {
      title: "BARE ALUMINIUM",
      icon: "⚪",
      color: "#1C1C1C",
      description: "Bare aluminium conductors for earthing and transmission",
      image: "/images/products/aluminium-single.jpg",
      specs: [
        "Bare Aluminium 50mm²",
        "Bare Aluminium 70mm²",
        "Bare Aluminium 95mm²",
        "Bare Aluminium 120mm²",
        "Bare Aluminium 150mm²",
        "Bare Aluminium 185mm²",
        "Bare Aluminium 240mm²"
      ],
      sizes: ["50mm²", "70mm²", "95mm²", "120mm²", "150mm²", "185mm²", "240mm²"],
      application: "Earthing, overhead transmission, busbars"
    }
  ];

  return (
    <div className="products-page">
      <div className="container">
        <h1 className="page-title">Our Products</h1>
        <p className="page-subtitle">Building Stronger Connections</p>
        
        <div className="products-showcase">
          {productCategories.map((product, index) => {
            const categoryId = getCategoryId(product.title);
            return (
              <div key={index} className={`product-showcase-card ${expandedCategory === index ? 'expanded' : ''}`}>
                <div className="product-showcase-header" onClick={() => toggleCategory(index)}>
                  {/* Image first */}
                  <div className="product-header-image" onClick={(e) => {
                    e.stopPropagation();
                    openLightbox(product.image, product.title);
                  }}>
                    <img src={product.image} alt={product.title} />
                    <span className="image-zoom-icon">🔍</span>
                  </div>
                  
                  {/* Name second */}
                  <div className="product-header-info">
                    <h2>{product.title}</h2>
                    <p className="product-description">{product.description}</p>
                  </div>
                  
                  {/* Icon third */}
                  <div className="product-icon">{product.icon}</div>
                  
                  {/* Expand icon last */}
                  <div className="expand-icon">
                    {expandedCategory === index ? '−' : '+'}
                  </div>
                </div>
                
                {expandedCategory === index && (
                  <div className="product-expanded-content">
                    <div className="product-specs">
                      <h3>Available Types</h3>
                      <ul>
                        {product.specs.map((spec, i) => (
                          <li key={i}>{spec}</li>
                        ))}
                      </ul>
                    </div>
                    
                    <div className="product-details">
                      {product.sizes && (
                        <div className="detail-section">
                          <h4>Sizes</h4>
                          <div className="size-grid">
                            {product.sizes.map((size, i) => (
                              <span key={i} className="size-tag">{size}</span>
                            ))}
                          </div>
                        </div>
                      )}
                      
                      {product.colors && (
                        <div className="detail-section">
                          <h4>Colors</h4>
                          <div className="size-grid">
                            {product.colors.map((color, i) => (
                              <span key={i} className="color-tag">{color}</span>
                            ))}
                          </div>
                        </div>
                      )}
                      
                      <div className="spec-item">
                        <span className="spec-label">Voltage:</span>
                        <span className="spec-value">{product.voltage || 'Various'}</span>
                      </div>
                      
                      <div className="spec-item">
                        <span className="spec-label">Standard:</span>
                        <span className="spec-value">{product.standard || 'Various'}</span>
                      </div>
                      
                      {product.insulation && (
                        <div className="spec-item">
                          <span className="spec-label">Insulation:</span>
                          <span className="spec-value">{product.insulation}</span>
                        </div>
                      )}
                      
                      {product.application && (
                        <div className="spec-item">
                          <span className="spec-label">Application:</span>
                          <span className="spec-value">{product.application}</span>
                        </div>
                      )}
                    </div>
                    
                    <div className="product-actions">
                      <Link to="/contact" className="btn btn-small">Request Quote</Link>
                      <Link 
                        to={`/catalogue?category=${categoryId}`} 
                        className="btn btn-small btn-outline"
                      >
                        View {product.title.split(' ')[0]} Catalogue
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="specialities-section">
          <h2>SPECIALITIES OF MASAI CABLES</h2>
          <div className="specialities-grid">
            <div className="speciality-item">✓ FIRE RETARDANT LOW SMOKE (FRLS) PVC</div>
            <div className="speciality-item">✓ EC GRADE 99.9% PURE COPPER</div>
            <div className="speciality-item">✓ EC GRADE ALUMINIUM</div>
            <div className="speciality-item">✓ IN-HOUSE MANUFACTURING</div>
            <div className="speciality-item">✓ MODERN TEST LABORATORY</div>
            <div className="speciality-item">✓ ISO 9001 - 2015 CERTIFIED</div>
            <div className="speciality-item">✓ WIDE VARIETY OF CABLE TYPES</div>
            <div className="speciality-item">✓ MULTIPLE SALES OUTLETS</div>
            <div className="speciality-item">✓ BIG MANUFACTURING CAPACITY</div>
          </div>
        </div>

        <div className="capacity-note">
          <p>***CALL OR WRITE TO US FOR CUSTOMISED CABLE TYPES & SIZES***</p>
          <p className="capacity-numbers">
            Manufacturing Capacity: 160 MT of Copper and 200 MT of Aluminium
          </p>
        </div>
      </div>

      {/* Lightbox for enlarged images */}
      {lightboxImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <span className="lightbox-close">&times;</span>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={lightboxImage} alt={lightboxTitle} />
            <p className="lightbox-caption">{lightboxTitle}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Products;